












































































































import { Vue, Component } from "vue-property-decorator";
import Api from "@/Api";

@Component
export default class AufgabenSchueler extends Vue {
  aufgabe: any = {};
  popupAufgabe = false;
  aufgabenDatum: any = "";
  aufgabenText = "";
  subtitle = "";
  editorButtons = [
    ["bold", "italic", "underline", "strikeThrough"],
    ["orderedList", "unorderedList"],
    ["alignLeft", "alignCenter", "alignRight", "alignJustify"]
  ];

  mounted() {
    this.aufgabe = (this.$f7route?.context as any).aufgabe;
    this.subtitle =
      this.aufgabe.klasse.title +
      " - " +
      this.aufgabe.fach.title +
      " - " +
      this.aufgabe.title;
    this.aufgabenDatum = [
      new Date(
        this.aufgabe.datum
          .split(".")
          .reverse()
          .join("-")
      )
    ];
    this.aufgabenText = this.aufgabe.text;
  }

  laden() {
    Api.get("/aufgaben/" + this.aufgabe.id).then(r => {
      console.log(r);
      this.aufgabe = r.data;
    });
  }

  speichern() {
    const datum = new Date(this.aufgabenDatum[0]);
    const jahr = datum.getFullYear();
    const monat = datum.getMonth() + 1;
    const tag = datum.getDate();
    Api.put("/aufgaben/" + this.aufgabe.id, {
      datum: tag + "." + monat + "." + jahr,
      text: this.aufgabenText
    }).then(r => {
      this.popupAufgabe = false;
      this.laden();
    });
  }

  entfernen() {
    Api.delete("/aufgaben/" + this.aufgabe.id).then(r => {
      this.laden();
    });
  }
}
